
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const SkinBoosters = () => {
  const treatmentData = {
    title: "Skin Boosters",
    subtitle: "Deep hydration injections for glowing, healthy skin",
    description: "Skin boosters are micro-injections of hyaluronic acid that hydrate skin from within, improving texture, elasticity, and overall skin quality for a natural, healthy glow.",
    whoItsFor: [
      "Those with dehydrated or dull skin",
      "People wanting overall skin quality improvement",
      "Anyone seeking preventative skin care",
      "Clients with fine lines from dehydration",
      "Those wanting natural-looking enhancement"
    ],
    packages: [
      {
        name: "Face Skin Boosters",
        visitorPrice: "$450",
        memberPrice: "$405",
        description: "Full face hydration treatment"
      },
      {
        name: "Face & Neck Package",
        visitorPrice: "$650",
        memberPrice: "$585",
        description: "Comprehensive hydration for face and neck"
      },
      {
        name: "Booster Series",
        visitorPrice: "$1,200",
        memberPrice: "$1,080",
        description: "Package of 3 treatments for lasting hydration"
      }
    ],
    beforeCare: [
      "Avoid blood thinners for 1 week",
      "Stay well hydrated",
      "Avoid alcohol 24 hours prior",
      "Come with clean, makeup-free skin"
    ],
    duringCare: [
      "Topical numbing for comfort",
      "Multiple micro-injections across treatment area",
      "45-60 minute treatment time",
      "Immediate post-treatment massage"
    ],
    afterCare: [
      "Avoid makeup for 6 hours",
      "Gentle skincare for 24 hours",
      "Stay hydrated",
      "Results improve over 2-4 weeks"
    ],
    memberPerks: [
      "10% discount on skin booster packages",
      "Complimentary hydrating skincare sample",
      "Free skin assessment and treatment planning",
      "Priority booking for maintenance treatments",
      "Access to professional hydrating products"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default SkinBoosters;
